import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import Snackbar from '@/components/Snackbar';
// import ChatbotButton from '@/modules/core/components/ChatbotButton/ChatbotButton';
import { BadAddressBannerContainer } from '@/modules/core/components/BadAddressBanner';
import { OrgLockBanner } from '@/modules/core/components/OrgLockBanner';
import Zendesk from '@/modules/core/components/Zendesk/Zendesk';
import { useLogSSOError, useOrganizationFavicon } from '@/modules/core/hooks';
import useLogoutOnTabClose from '@/modules/core/hooks/useLogoutOnTabClose';
import { useAuthStore } from '@/modules/user';
import { LimitedAccessBanner } from '@/modules/user/components/LimitedAccess';
import { useVersionChecker } from '@/utils';
import whiteLabelingConfig, { THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

import { ContinueInAppPopupStandalone } from '../ContinueInAppPopup';
import DashboardWrapper from '../DashboardWrapper';
import { ErrorBoundary } from '../ErrorBoundary';

import useAppRedirect from './useAppRedirect';

import './App.css';

const TimeoutModal = lazy(() => import('../TimeoutModal'));

function App() {
  const { loading, routes } = useAppRedirect();
  useVersionChecker();
  useOrganizationFavicon();
  // useWhiteLabelingFavicon();
  const auth = useAuthStore((state) => state.auth);
  useLogoutOnTabClose({ isLoggedIn: auth });
  useLogSSOError();

  if (loading) {
    return null;
  }

  return (
    <>
      <Snackbar />
      {THEMES.gusto === whiteLabelingConfig.title || THEMES.rippling === whiteLabelingConfig.title ? null : (
        <ContinueInAppPopupStandalone />
      )}

      {auth && (
        <Suspense fallback={null}>
          <TimeoutModal />
        </Suspense>
      )}
      <LimitedAccessBanner />
      <OrgLockBanner />
      <BadAddressBannerContainer />
      <DashboardWrapper>
        <ErrorBoundary>
          <Switch>
            {routes.map((route) => (
              <Route key={`${route.path}`} {...route} />
            ))}
          </Switch>
        </ErrorBoundary>
      </DashboardWrapper>
      {/* {auth && <ChatbotButton />} */}
      {auth && <Zendesk />}
    </>
  );
}

export default App;
